<!--关于页面header Sag 2020-03-25-->
<template>
  <div class="its-about-header its-image">
    <class-title class="its-about-class-title" :title="about.title"></class-title>
    <div class="its-about-info its-image">
      <div class="its-about-user its-image">
        <div class="its-user-intro">
          <div class="its-user-intro-name">{{about.user}}</div>
          <div class="its-user-intro-item">{{about.intro}}</div>
        </div>
      </div>
      <div class="its-about-user-intro" v-html="about.desc"></div>
    </div>
  </div>
</template>
<script>
import ClassTitle from '../../home/components/ClassTitle'
export default {
  name: 'AboutHeader',
  components: {
    ClassTitle
  },
  props: {
    about: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>
<style scoped>
.its-about-header{
  width: 100%;
  height: 765px;
  background:url(../../../../../public/images/about_header_bg.png);
  background-size: 100%;
  position: relative;
}
.its-about-info{
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 1253px;
  height: 583px;
  top: 290px;
  background-image: url(../../../../../public/images/about_header_info_bg.png);
}
.its-image{
  background-repeat: no-repeat;
}
.its-about-user{
  width: 283px;
  height: 402px;
  position: absolute;
  left: 81px;
  top: 87px;
  background-image: url(../../../../../public/images/about_header_info_user.png);
}
.its-about-class-title{
  position: absolute;
  top: 165px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.its-about-class-title>>>.its-title{
  color: white;
  margin-top: 0;
}
.its-about-class-title>>>.its-border{
  background: white;
}
.its-about-user-intro{
  width: 732px;
  position: absolute;
  left: 420px;
  top: 107px;
}
.its-about-user-intro>>>.its-about-intro-item{
  text-indent:36px;
  font-size: 18px;
  color: #3F466A;
  font-family:PingFang SC;
  font-weight:500;
  line-height: 36px;
  text-align: justify;
}
.its-about-user-intro>>>.its-about-intro-item .its-strong{
  color: #3F466A;
  font-size: 24px;
}

.its-about-user-intro >>> .its-about-title {
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 20px;
  color: #3F466A;
  font-family:PingFang SC;
  font-weight:600;
}

.its-user-intro{
  position: absolute;
  bottom: 17px;
  width: 100%;
  text-align: center;
}
.its-user-intro .its-user-intro-name{
  line-height: 1;
  font-size:18px;
  font-family:PingFang SC;
  color: white;
  margin-bottom: 5px;
}
.its-user-intro .its-user-intro-item{
  line-height: 1;
  font-size:16px;
  font-family:PingFang SC;
  color: white;
}
</style>
